// Module
var code = "<ui-view></ui-view> ";
// Exports
export default code;